import React, { useEffect, useState } from "react";
import { api, waLink } from "../lib/api";
import { Ship, Clock, MessageCircle } from "lucide-react";
import LeadForm from "../components/LeadForm";
import Seo from "../components/Seo";

export default function Cruise() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/cruises").then(r => setItems(r.data)); }, []);
  return (
    <div className="pt-24 lg:pt-28">
      <Seo title="Cruise Holidays" path="/cruise" description="All-inclusive luxury cruise holidays — Singapore Cruise, Royal Caribbean and Cordelia Cruises from India. World-class dining, entertainment and cabins." />
      <section className="container-p">
        <span className="section-label">Cruise Holidays</span>
        <h1 className="h1 mt-3">All-inclusive luxury on the high seas</h1>
        <p className="muted mt-4 max-w-2xl">Singapore, Royal Caribbean, Cordelia — sail to iconic destinations with world-class dining, entertainment and cabin experiences.</p>
      </section>

      <section className="container-p mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map(c => (
          <div key={c.id} className="card-glass overflow-hidden group hover:-translate-y-1 transition" data-testid={`cruise-${c.id}`}>
            <div className="aspect-[16/10] overflow-hidden"><img src={c.image} alt={c.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" /></div>
            <div className="p-6">
              <div className="flex items-center gap-2 mb-2"><Ship className="w-4 h-4 text-[#006CE4]" /><span className="text-xs uppercase tracking-widest muted">Cruise</span></div>
              <h3 className="h3">{c.name}</h3>
              <p className="text-sm muted mt-2 leading-relaxed">{c.description}</p>
              <div className="flex items-center justify-between mt-5">
                <div>
                  <div className="text-xs muted flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {c.duration}</div>
                  <div className="font-display font-bold text-xl text-[#0A2540] mt-1">₹{c.price.toLocaleString("en-IN")}</div>
                </div>
                <a href={waLink(`Hi, I'm interested in ${c.name}.`)} target="_blank" rel="noopener noreferrer" className="btn-wa"><MessageCircle className="w-4 h-4" /> Enquire</a>
              </div>
            </div>
          </div>
        ))}
      </section>

      <section className="section container-p"><div className="card-glass p-8 md:p-12"><LeadForm title="Plan Your Cruise Holiday" source="cruise" /></div></section>
    </div>
  );
}
